import React from "react";
import { useTranslation } from "react-i18next";

const LeftPanel = () => {
  const { t } = useTranslation("auth");

  return (
    <div className="leftPanel">
      <h1 className="px-5">{t("welcomeMsg")}</h1>
      <div className="image-container fieldset px-5">
        <img
          src={require("../../assets/images/masked-chrous-device-img.png")}
          className="img-fluid chorus-img"
          alt="signin"
        />
        <span className="deviceSubTitle">{t("imgText")}</span>
      </div>
    </div>
  );
};

export default LeftPanel;
